import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Text, IconButton, VStack, HStack } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { CloseIcon } from '@chakra-ui/icons';
import { subscribeToAlarms, dismissAlarm } from '../../lib/micu/alarmManager';

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
`;

const AlarmBanner = () => {
  const [alarms, setAlarms] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = subscribeToAlarms(setAlarms);
    return unsubscribe;
  }, []);

  if (alarms.length === 0) return null;

  return (
    <VStack
      spacing={0}
      position="fixed"
      top="48px"
      left={0}
      right={0}
      zIndex={200}
    >
      {alarms.map(alarm => (
        <Flex
          key={alarm.medicationId}
          w="100%"
          bg={alarm.minutesRemaining <= 0 ? 'red.600' : 'orange.500'}
          animation={`${pulse} 1.5s ease-in-out infinite`}
          px={4}
          py={2}
          align="center"
          justify="space-between"
          cursor="pointer"
          onClick={() => navigate(`/micu-mobile/case/${alarm.caseId}/med/${alarm.medicationId}`)}
        >
          <HStack spacing={2}>
            <Text color="white" fontWeight="bold" fontSize="sm">
              {alarm.drugName}
            </Text>
            <Text color="whiteAlpha.900" fontSize="sm">
              {alarm.minutesRemaining <= 0 ? 'EMPTY' : `${alarm.minutesRemaining} min remaining`}
            </Text>
          </HStack>
          <IconButton
            icon={<CloseIcon />}
            size="xs"
            variant="ghost"
            color="white"
            _hover={{ bg: 'whiteAlpha.200' }}
            aria-label="Dismiss alarm"
            onClick={(e) => {
              e.stopPropagation();
              dismissAlarm(alarm.medicationId);
            }}
          />
        </Flex>
      ))}
    </VStack>
  );
};

export default AlarmBanner;
